var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3More(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E3_more_svg__clip0_1288_115641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.067 22.528a7.856 7.856 0 100-15.712 7.856 7.856 0 000 15.712zM37.067 44.65a7.856 7.856 0 100-15.713 7.856 7.856 0 000 15.712zM37.067 67.184a7.856 7.856 0 100-15.712 7.856 7.856 0 000 15.712z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "E3_more_svg__clip0_1288_115641"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h74v74H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/E3_more.163d3b79.svg";
export { SvgE3More as ReactComponent };